<div [dir]="this.app.getUserDire()">
    <h3 class="mb-4" matDialogTitle>
        {{ 'bookingPopUp.Services' | translate }}
    </h3>
    <!-- translate.get('Choose service') | async -->
    <mat-dialog-content class="my-5"> 
    
        <!-- <ng-select [items]="Services" 
                   bindLabel="name" 
                   bindValue="id"
                   placeholder="{{ 'bookingPopUp.Choose service' | translate }}"
                   appendTo="body" 
                   [multiple]="false" 
                   class="asd"
                   [(ngModel)]="ServiceValue">
        </ng-select>  -->
    
        <mat-form-field class="w-100" appearance="legacy">
            <mat-label class="mx-4">{{ 'bookingPopUp.ChooseService' | translate }}</mat-label>
            <mat-select [(ngModel)]="ServiceValue">
                <mat-option *ngFor="let service of Services" [value]="service.id">
                    {{service.name}}</mat-option>
            </mat-select>
        </mat-form-field>
        
    </mat-dialog-content> 
    <mat-dialog-actions class="flex justify-end justify-content-end w-100">
        <button mat-button mat-dialog-close> {{ 'bookingPopUp.CLOSE' | translate }} </button>
        <button class="save d-flex jus" 
                [class.disabled]="!ServiceValue"
                [disabled]="!ServiceValue" 
                [routerLink]="['/' + this?.app?.languageCode + '/booking']"
                [queryParams]="{ 'serviceId' : ServiceValue , 'doctorId': this.doctor?.id, 'hcpId' : this.doctor?.userId }"
                (click)="dialog.close()"
                mat-raised-button> 
                {{ 'bookingPopUp.Go Booking' | translate }}  
        </button>
    </mat-dialog-actions>
</div>